function animateWobble(element) {
	const duration = 2000 + (Math.random() * 1500);
	const y = -(1 + (Math.random() * 2));

	const animation = element.animate(
		[
			{ transform: 'translateY(0)', easing: 'ease-in-out' },
			{ transform: `translateY(${y}px)`, offset: 0.5, easing: 'ease-in-out' },
			{ transform: 'translateY(0)', easing: 'ease-in-out' },
		],
		{ duration, fill: 'none' },
	);

	animation.onfinish = () => animateWobble(element);
}

document.addEventListener('DOMContentLoaded', () => {
	const floatingLogos = document.querySelector('.is-floating-logos');

	if (!floatingLogos) {
		return;
	}

	const logos = floatingLogos.querySelectorAll('[class*="logo-"]');

	const observerOptions = {
		root: null,
		threshold: 0.5,
	};

	const observer = new IntersectionObserver((entries, observer) => {
		for (const entry of entries) {
			if (entry.isIntersecting) {
				// Create a shuffled copy of the array
				const shuffledLogos = [...logos].sort(() => Math.random() - 0.5);

				for (const logo of shuffledLogos) {
					const randomDelay = (Math.random() * 550) + 50;

					setTimeout(() => {
						logo.classList.add('active');

						logo.addEventListener('animationend', () => {
							animateWobble(logo);
						}, { once: true });
					}, randomDelay);
				}

				// Stop observing once the animation has started
				observer.unobserve(entry.target);
			}
		}
	}, observerOptions);

	observer.observe(floatingLogos);
});
